// @ts-nocheck
/* global Autodesk, THREE */

import { uniq } from 'lodash';
import { forgeAuth } from "./apiForge";
import TemperaturePanelExtension from './TemperaturePanellExtension';
import PressurePanelExtension from './PressurePanelExtension';
import VibrationPanelExtension from './VibrationPanelExtension';
import FlowPanelExtension from './FlowPanelExtension';

import CameraPanelExtension from './CameraPanelExtension';

import ProjectData from '../Data/sampleprojectdata.json';

// import './Transform'

// var chartPanel = '';
var viewer;
var explodeScale = 0;
var startExplosion = null;
var explosionReq;
var isExploding = false;
var outwardExplosion = true;
var startRotation = null;
var rotationReq;
var isRotating = false;
var tileId = '';
var selectedDbId = 0
var viewerElement
var showSensors

export var properties = {};
let viewableData = null

function launchViewer(urn, id, extensions, hasDwg, viewerDiv, showSens) {
    tileId = id;
    showSensors = showSens
    forgeAuth().then(token => {
        var options = {
            'document': urn,
            'env': 'MD20ProdUS', //'AutodeskProduction',
            'api': 'D3S',
            'accessToken': token.access_token
            // 'refreshToken': getForgeToken
        };

        viewerElement = document.getElementById(viewerDiv);
        // viewer = new Autodesk.Viewing.Viewer3D(viewerElement, {});
        viewer = new Autodesk.Viewing.GuiViewer3D(viewerElement, {});

        // setup the viewer look and feel
        const profileSettings = {
            name: "mySettings",
            description: "My personal settings.",
            settings: {
                ambientShadows: true,
                groundShadows: true,
                groundReflection: true,
                ghosting: true,
                envMapBackground: false,
                // lightPreset: 8,
                explodeStrategy: 'radial',
                // openPropertiesOnSelect: true,
                // edgeRendering: true,
                displayUnits: 'ft-and-decimal-in'
            },
            extensions: {
                // load: ["panelExtension"],   // Extensions to load
                load: extensions,   //['HeatmapExtension', 'IssuesExtension', 'AnimationExtension'],   // Extensions to load
                unload: ['Autodesk.BimWalk']
                // load: ["Viewing.Extension.Transform"],   // Extensions to load
            }
        }
        //// ------ transformation testing --------
        let mainModel = null;
        let secondModel = null;
        let extraZ = 0;

        document.onkeydown = event => {
            if (!event.shiftKey)
                return;

            if (event.code === "ArrowRight") {
                console.log('ArrowRight')
                transformModel(100, 'y')
            }

            if (event.code === "ArrowLeft") {
                console.log('ArrowLeft')
                transformModel(-100, 'y')

            }

            if (event.code === "ArrowUp") {
                console.log('ArrowUp')
                transformModel(100, 'x')

            }

            if (event.code === "ArrowDown") {
                console.log('ArrowDown')
                transformModel(-100, 'x')

            }
        };

        document.onmousemove = event => {
            if (!event.ctrlKey)
                return;

            let res = viewer.impl.hitTest(event.clientX, event.clientY, true, null, [mainModel.getModelId()]);
            let pt = null;

            if (res) {
                pt = res.intersectPoint;
            } else {
                pt = viewer.impl.intersectGround(event.clientX, event.clientY);
            }

            let tr = secondModel.getPlacementTransform();
            tr.elements[12] = pt.x;
            tr.elements[13] = pt.y;
            tr.elements[14] = pt.z + extraZ;
            secondModel.setPlacementTransform(tr);
            viewer.impl.invalidate(true, true, true);
        }

        //// ------ end of transformation testing --------


        // const profileSettings = Autodesk.Viewing.ProfileSettings.Navis;
        const profile = new Autodesk.Viewing.Profile(profileSettings);

        Autodesk.Viewing.endpoint.HTTP_REQUEST_HEADERS['If-Modified-Since'] = "Sat, 29 Oct 1994 19:43:31 GMT"

        Autodesk.Viewing.Initializer(
            options,
            function () {
                viewer.initialize();
                viewer.setTheme("light-theme")

                viewer.setProfile(profile);
                viewer.config.modelBrowserExcludeRoot = false

                loadDocument(options.document, hasDwg);
            }
        );
    })
}

function loadDocument(documentId, hasDwg) {


    Autodesk.Viewing.Document.load(
        documentId,
        function (doc) { // onLoadCallback

            var viewables = doc.getRoot().search({ 'type': 'geometry' })

            viewer.loadDocumentNode(doc, viewables[hasDwg], {
                // preserveView: true,
                // keepCurrentModels: true,
                // placementTransform: (new THREE.Matrix4()).setPosition(),
                // keepCurrentModels: true,
                globalOffset: { x: 0, y: 0, z: 0 }
            })
                .then(onLoadFinished);


            // // var geometryItems = Autodesk.Viewing.Document.getSubItemsWithProperties(doc.getRoot(), { 'type': 'geometry' }, true);
            // var geometryItems = doc.getRoot().search({ 'type': 'geometry' })
            // if (geometryItems.length > 0) {
            //     geometryItems.forEach(function (item, index) {
            //     });
            //     viewer.addEventListener(Autodesk.Viewing.GEOMETRY_LOADED_EVENT, onGeometryLoaded);
            //     viewer.addEventListener(Autodesk.Viewing.AGGREGATE_SELECTION_CHANGED_EVENT, debounce(() => {
            //         console.log('selection change')
            //         getModelProperties()
            //             .then((modelProperties) =>
            //                 store.dispatch(actions.getViewerProperties(modelProperties))
            //             )
            //             .catch(() =>
            //                 store.dispatch(actions.getViewerProperties([]))
            //             )
            //     }), 200);

            //     viewer.loadDocumentNode(doc.getViewablePath(geometryItems[0])); // show 1st view on this document...
            // }            
        },
        function (errorMsg) { // onErrorCallback
            console.log(errorMsg);
        }
    )

}

function onGeometrySelected(doc) {
    // console.log(doc)
    // var domElem = document.getElementById('selectedForgeItem');   
    // domElem.innerText = 'Item Selected: ' + doc.dbIdArray;   
    //viewer.isolate(doc.dbIdArray)
    selectedDbId = doc.dbIdArray
    console.log(doc)
    const sensorInformationSection = document.getElementById("selectedEquipmentId");
    sensorInformationSection.innerText = selectedDbId
    
};

export function getCurrentId() {
    return selectedDbId
}


function onLoadFinished(doc) {

    viewer.addEventListener(Autodesk.Viewing.SELECTION_CHANGED_EVENT, onGeometrySelected);
    console.log('loaded');
    viewer.setFocalLength(22)
    viewer.setLightPreset(3)
    viewer.setQualityLevel(true, true)
    buildSensors(showSensors)
    viewer.fitToView();
    localStorage.setItem('activeProjName', 'DemoStation');

}


export function hideModel(dbIList) {

    for (var i = 0; i < dbIList.length; i++) {
        viewer.impl.visibilityManager.setNodeOff(dbIList[i], true) // true=hide, false=show
        viewer.impl.sceneUpdated(true);
    }

};

export async function hideItemByName(itemList) {


    if (itemList.length > 0) {
        // viewer.setGhosting(true);
        await viewer.search(itemList[0], function (dbIds) {
            // here the dbIds is a list of dbIds, you can handle it        
            // console.log(dbIds)
            // viewer.impl.visibilityManager.setNodeOff(dbIds[0], val) // true=hide, false=show
            viewer.isolate([dbIds[0]]);
            viewer.fitToView([dbIds[0]]);
            viewer.impl.sceneUpdated(true);
        }, function (error) {
            // handle errors here...
        }, ['name'] /* this array indicates the filter: search only on 'Name'*/
        )
    } else {
        viewer.setGhosting(true);
    }
};



export async function loadNestedViewer(status) {
    // const nestedViewer = await viewer.loadExtension("NestedViewerExtension");
};


export async function buildSensors(status) {
    // const activeProjName = localStorage.getItem('activeProjName');

    const dataVizExtn = await viewer.loadExtension("Autodesk.DataVisualization", {
        useInternal: true,
    });
    //const fans = ["fan-00.svg", "fan-01.svg", "fan-02.svg", "fan-03.svg"];
    // @TODO: setup sprite anmimations
    // https://forge.autodesk.com/en/docs/dataviz/v1/developers_guide/examples/animate_sprites/
    const DataVizCore = Autodesk.DataVisualization.Core;

    const viewableType = DataVizCore.ViewableType.SPRITE;
    const sensorColor = new THREE.Color(0xffffff);
    const baseURL = "/images/";
    const oilTempSensorIconUrl = `${baseURL}OilTempSensor.png`;
    const moistureSensorIconUrl = `${baseURL}MoistureSensor.png`;
    const dgaSensorIconUrl = `${baseURL}dga.png`;
    const sf6SensorIconUrl = `${baseURL}GasDischargeSensor.png`;
    const voltageSensorIconUrl = `${baseURL}voltageSensor.png`;
    const cameraSensorIconUrl = `${baseURL}Camera.png`;
    const weatherSensorIconUrl = `${baseURL}WeatherSensor.png`;
    const lightningSensorIconUrl = `${baseURL}LightningSensor.png`;

    const oilTempStyle = new DataVizCore.ViewableStyle(viewableType, sensorColor, oilTempSensorIconUrl);
    const moistureStyle = new DataVizCore.ViewableStyle(viewableType, sensorColor, moistureSensorIconUrl);
    const dgaStyle = new DataVizCore.ViewableStyle(viewableType, sensorColor, dgaSensorIconUrl);
    const sf6Style = new DataVizCore.ViewableStyle(viewableType, sensorColor, sf6SensorIconUrl);
    const voltageStyle = new DataVizCore.ViewableStyle(viewableType, sensorColor, voltageSensorIconUrl);
    const cameraStyle = new DataVizCore.ViewableStyle(viewableType, sensorColor, cameraSensorIconUrl);
    const weatherStyle = new DataVizCore.ViewableStyle(viewableType, sensorColor, weatherSensorIconUrl);
    const lightningStyle = new DataVizCore.ViewableStyle(viewableType, sensorColor, lightningSensorIconUrl);

    viewableData = new DataVizCore.ViewableData();
    viewableData.spriteSize = 36; // Sprites as points of size 24 x 24 pixels    

    const projectName = localStorage.getItem("projectName")
    const projectDetails = ProjectData.find(project => project.name === projectName);
    let oiltempSensors = projectDetails.oiltempSensors
    let moistureSensors = projectDetails.moistureSensors
    let dgaSensors = projectDetails.dgaSensors
    let sf6Sensors = projectDetails.sf6Sensors
    let voltageSensors = projectDetails.voltageSensors
    let cameraSensors = projectDetails.cameraSensors
    let weatherSensors = projectDetails.weatherSensors
    let lightningSensors = projectDetails.lightningSensors

    localStorage.setItem("activeUrn", projectDetails.modelUrn)
    oiltempSensors.forEach((oiltempData, i) => {
        const dbId = 10 + i;
        const position = oiltempData.position;
        const oilTempViewable = new DataVizCore.SpriteViewable(position, oilTempStyle, dbId);

        // Tag custom data on this instance of `SpriteViewable` for later use.
        oilTempViewable.sensorContextData = {
            sensorId: oiltempData.deviceId,
            sensorType: oiltempData.type,
            labels: ["In Service", "Passive"],
        };
        viewableData.addViewable(oilTempViewable);
    });

    moistureSensors.forEach((moistureData, n) => {
        const dbId = 20 + n;
        const position = moistureData.position;
        const moistureViewable = new DataVizCore.SpriteViewable(position, moistureStyle, dbId);

        // Tag custom data on this instance of `SpriteViewable` for later use.
        moistureViewable.sensorContextData = {
            sensorId: moistureData.deviceId,
            sensorType: moistureData.type,
            labels: ["In Service", "Passive"],
        };
        viewableData.addViewable(moistureViewable);
    });
    // console.log('dga sensors')
    // console.log(dgaSensors)
    dgaSensors.forEach((dgaData, t) => {
        const dbId = 30 + t;
        const position = dgaData.position;
        const dgaViewable = new DataVizCore.SpriteViewable(position, dgaStyle, dbId);

        // Tag custom data on this instance of `SpriteViewable` for later use.
        dgaViewable.sensorContextData = {
            sensorId: dgaData.deviceId,
            sensorType: dgaData.type,
            labels: ["In Service", "Passive"],
        };
        viewableData.addViewable(dgaViewable);
    });

    sf6Sensors.forEach((df6Data, t) => {
        const dbId = 40 + t;
        const position = df6Data.position;
        const sf6Viewable = new DataVizCore.SpriteViewable(position, sf6Style, dbId);

        // Tag custom data on this instance of `SpriteViewable` for later use.
        sf6Viewable.sensorContextData = {
            sensorId: df6Data.deviceId,
            sensorType: df6Data.type,
            labels: ["In Service", "Passive"],
        };
        viewableData.addViewable(sf6Viewable);
    });

    voltageSensors.forEach((voltageData, t) => {
        const dbId = 50 + t;
        const position = voltageData.position;
        const voltageViewable = new DataVizCore.SpriteViewable(position, voltageStyle, dbId);

        // Tag custom data on this instance of `SpriteViewable` for later use.
        voltageViewable.sensorContextData = {
            sensorId: voltageData.deviceId,
            sensorType: voltageData.type,
            labels: ["In Service", "Passive"],
        };
        viewableData.addViewable(voltageViewable);
    });

    // cameraSensors.forEach((cameraData, t) => {
    //     const dbId = 60 + t;
    //     const position = cameraData.position;
    //     const cameraViewable = new DataVizCore.SpriteViewable(position, cameraStyle, dbId);

    //     // Tag custom data on this instance of `SpriteViewable` for later use.
    //     cameraViewable.sensorContextData = {
    //         sensorId: cameraData.deviceId,
    //         sensorType: cameraData.type,
    //         labels: ["In Service", "Passive"],
    //     };
    //     viewableData.addViewable(cameraViewable);
    // });

    weatherSensors.forEach((weatherData, t) => {
        const dbId = 70 + t;
        const position = weatherData.position;
        const weatherViewable = new DataVizCore.SpriteViewable(position, weatherStyle, dbId);

        // Tag custom data on this instance of `SpriteViewable` for later use.
        weatherViewable.sensorContextData = {
            sensorId: weatherData.deviceId,
            sensorType: weatherData.type,
            labels: ["In Service", "Passive"],
        };
        viewableData.addViewable(weatherViewable);
    });

    lightningSensors.forEach((lightningData, t) => {
        const dbId = 80 + t;
        const position = lightningData.position;
        const lightningViewable = new DataVizCore.SpriteViewable(position, lightningStyle, dbId);

        // Tag custom data on this instance of `SpriteViewable` for later use.
        lightningViewable.sensorContextData = {
            sensorId: lightningData.deviceId,
            sensorType: lightningData.type,
            labels: ["In Service", "Passive"],
        };
        viewableData.addViewable(lightningViewable);
    });

    if (status === true) {
        await viewableData.finish();
        dataVizExtn.addViewables(viewableData);
        const showViewables = true;
        const enableOcclusion = false;
        dataVizExtn.showHideViewables(showViewables, enableOcclusion);
        viewer.addEventListener(Autodesk.DataVisualization.Core.MOUSE_HOVERING, onItemHovering);
        viewer.addEventListener(Autodesk.DataVisualization.Core.MOUSE_CLICK, onSensorClick);
    } else {
        dataVizExtn.removeAllViewables();
    }
};

// could implement some note on hover.
function onItemHovering(event) {
    const projectName = localStorage.getItem("projectName")
    const projectDetails = ProjectData.find(project => project.name === projectName);

    if (event.hovering) {
        console.log(event);
    }
    else {
        const sensorInformationSection = document.getElementById("sensorInformationSection");

        let sensorCompleteList = [...projectDetails.oiltempSensors,
        ...projectDetails.moistureSensors,
        ...projectDetails.dgaSensors,
        ...projectDetails.sf6Sensors,
        ...projectDetails.voltageSensors,
        ...projectDetails.cameraSensors,
        ...projectDetails.weatherSensors,
        ...projectDetails.lightningSensors
        ]
        // console.log(sensorCompleteList)

        var deviceHoveredOn = sensorCompleteList.find(sensor => sensor.dbId === event.dbId)
        sensorInformationSection.innerText = deviceHoveredOn.deviceId
    }
}


export function getdbId() {

    const dbId = viewer.getSelection()[0];
    return dbId
};

// launches the chart example (React panel)
function onSensorClick(event) {
    // The identifier of the `SpriteViewable` that is being clicked.
    const targetDbId = event.dbId;

    if (event.dbId !== 0) {
        // Look up the corresponding sprite viewable from `viewableData`.
        const viewables = viewableData.viewables;
        const viewable = viewables.find((v) => v.dbId === targetDbId);

        console.log(viewable)

        if (viewable && viewable.sensorContextData) {
            const data = viewable.sensorContextData;
            console.log(`Sensor Id: ${data.sensorId}`);
            console.log(`Sensor type: ${data.sensorType}`);
            localStorage.setItem('activeDeviceId', data.sensorId);
            //alert(data.sensorType)
            switch (data.sensorType) {
                case 'oiltemperature':
                    viewer.unloadExtension(TemperaturePanelExtension);
                    viewer.loadExtension(TemperaturePanelExtension);
                    break;
                case 'moisture':
                    viewer.unloadExtension(PressurePanelExtension);
                    viewer.loadExtension(PressurePanelExtension);
                    break;
                case 'dga':
                    viewer.unloadExtension(VibrationPanelExtension);
                    viewer.loadExtension(VibrationPanelExtension);
                    break;
                case 'sf6':
                    viewer.unloadExtension(FlowPanelExtension);
                    viewer.loadExtension(FlowPanelExtension);
                    break;
                case 'camera':
                    viewer.unloadExtension(CameraPanelExtension);
                    viewer.loadExtension(CameraPanelExtension);
                    break;
                case 'voltage':
                    viewer.unloadExtension(FlowPanelExtension);
                    viewer.loadExtension(FlowPanelExtension);
                    break;
                case 'weather':
                    viewer.unloadExtension(FlowPanelExtension);
                    viewer.loadExtension(FlowPanelExtension);
                    break;
                case 'lightning':
                    viewer.unloadExtension(FlowPanelExtension);
                    viewer.loadExtension(FlowPanelExtension);
                    break;
                default:
                    break;
            }
        }


    }
}


//////////////////////////////////////////////////////////////////////////
// Model Geometry loaded callback
//
//////////////////////////////////////////////////////////////////////////
// function onGeometryLoaded(event) {
//     var viewer = event.target;
//     viewer.removeEventListener(
//         Autodesk.Viewing.GEOMETRY_LOADED_EVENT,
//         onGeometryLoaded);
//     viewer.fitToView();
//     // viewer.setQualityLevel(false, false); // Getting rid of Ambientshadows to false to avoid blackscreen problem in Viewer.
// }

export function moveModel(dist) {

    return new Promise((resolve, reject) => {
        const dbId = viewer.getSelection()[0];

        if (viewer.getSelectionCount() !== 1) {
            return reject('Invalid selection count');
        }
        let tree = viewer.model.getData().instanceTree;



        tree.enumNodeFragments(dbId, function (frag) {
            var fragProxy = viewer.impl.getFragmentProxy(viewer.model, frag);
            fragProxy.getAnimTransform();
            fragProxy.position.y = fragProxy.position.y + dist
            fragProxy.updateAnimTransform();
        });
        viewer.impl.sceneUpdated(true);

        resolve(tree);
    });

};

function transformModel(dist, direction) {

    return new Promise((resolve, reject) => {
        const dbId = viewer.getSelection()[0];

        if (viewer.getSelectionCount() !== 1) {
            return reject('Invalid selection count');
        }
        let tree = viewer.model.getData().instanceTree;

        tree.enumNodeFragments(dbId, function (frag) {
            var fragProxy = viewer.impl.getFragmentProxy(viewer.model, frag);
            fragProxy.getAnimTransform();
            if (direction === 'y') { fragProxy.position.y = fragProxy.position.y + dist }
            if (direction === 'x') { fragProxy.position.x = fragProxy.position.x + dist }
            fragProxy.updateAnimTransform();
        });
        // viewer.impl.sceneUpdated(true);

        resolve(tree);
    });

};



export async function getModelProperties() {
    return new Promise((resolve, reject) => {
        const dbId = viewer.getSelection()[0];

        if (viewer.getSelectionCount() !== 1) {
            return reject('Invalid selection count');
        }

        return new Promise((resolve) => {
            viewer.model.getProperties(dbId, (item) => {
                const items = item.properties.filter((property) => !property.hidden);
                resolve(items);
            });
        })
            .then((list) => {

                // Normalize displayCategory property in case it's falsy
                list = list.map(item => ({
                    ...item,
                    displayCategory: item.displayCategory || 'Miscellaneous'
                }));

                // Unique list of categories
                const categories = uniq(list.map(item => item.displayCategory));

                // Model data to be consumed
                // Ex: [ {category: 'Miscellaneous', data: []} ]
                const properties = categories.map(category => (
                    {
                        category,
                        data: list.filter(item => item.displayCategory === category)
                    }
                ));
                console.log(properties)
                resolve(properties);
            });
    });
}

export function viewerResize() {
    //   viewer.resize();
}

export function viewerExplode(num) {
    viewer.explode(num);
}

export function modelRestoreState() {
    var originalState = "";

    switch (tileId) {
        // case "0001":
        //     originalState = JSON.parse('{"guid":"f075a989156eb711398","seedURN":"dXJuOmFkc2sub2JqZWN0czpvcy5vYmplY3Q6Y29uZmlnX2hzc3RzdHJ1Y3R1cmUvSFNTX0luc3RydW1lbnRfVC5pZHc","overrides":{"transformations":[]},"objectSet":[{"id":[],"isolated":[],"hidden":[],"explodeScale":0,"idType":"lmv"}],"viewport":{"name":"","eye":[145.8184640788883,93.51676504768685,-124.19785909734301],"target":[0,0,0.0000019073486328125],"up":[-0.3340034881841154,0.8986169812472194,0.28448056329910826],"worldUpVector":[0,1,0],"pivotPoint":[0,0,0.0000019073486328125],"distanceToOrbit":213.15139804714164,"aspectRatio":1.9929737351528332,"projection":"perspective","isOrthographic":false,"fieldOfView":61.92751520437556},"renderOptions":{"environment":"Rim Highlights","ambientOcclusion":{"enabled":false,"radius":10,"intensity":0.4},"toneMap":{"method":1,"exposure":-9,"lightMultiplier":-1e-20},"appearance":{"ghostHidden":true,"ambientShadow":false,"antiAliasing":true,"progressiveDisplay":true,"displayLines":true}},"cutplanes":[]}');
        //     console.log("Restoring State for Tile:", tileId);
        //     break;
        // case "0002":
        //     originalState = JSON.parse('{"guid":"f075a989156eb711397","seedURN":"dXJuOmFkc2sub2JqZWN0czpvcy5vYmplY3Q6Y29uZmlnX3Rlc3RibG9ja3MvVGVzdEJsb2Nrcy56aXA","overrides":{"transformations":[]},"objectSet":[{"id":[],"isolated":[],"hidden":[],"explodeScale":0,"idType":"lmv"}],"viewport":{"name":"","eye":[268.15901156738664,268.1590007567955,268.15899179720685],"target":[0,-0.0000019073486328125,-0.00000762939453125],"up":[0,1,0],"worldUpVector":[0,1,0],"pivotPoint":[0,-0.0000019073486328125,-0.00000762939453125],"distanceToOrbit":464.4650203923889,"aspectRatio":1.9409698157397892,"projection":"orthographic","isOrthographic":true,"orthographicHeight":464.46502039238896},"renderOptions":{"environment":"Rim Highlights","ambientOcclusion":{"enabled":false,"radius":10,"intensity":0.4},"toneMap":{"method":1,"exposure":-9,"lightMultiplier":-1e-20},"appearance":{"ghostHidden":true,"ambientShadow":false,"antiAliasing":true,"progressiveDisplay":true,"displayLines":true}},"cutplanes":[]}');
        //     console.log("Restoring State for Tile:", tileId);
        //     break;
        // case "0003":
        //     originalState = JSON.parse('{"guid":"f075a989156eb711399","seedURN":"dXJuOmFkc2sub2JqZWN0czpvcy5vYmplY3Q6Y29uZmlnX2hzc2luc3RydW1lbnRpL0hTU19JbnN0cnVtZW50X0kuemlw","overrides":{"transformations":[]},"objectSet":[{"id":[],"isolated":[],"hidden":[],"explodeScale":0,"idType":"lmv"}],"viewport":{"name":"","eye":[947.8717757705549,-947.8718237856292,947.8718169263327],"target":[0,0,0],"up":[0,1,0],"worldUpVector":[0,1,0],"pivotPoint":[0,0,0],"distanceToOrbit":1641.7621261779516,"aspectRatio":2.47171569916115,"projection":"orthographic","isOrthographic":true,"orthographicHeight":1641.7621261779514},"renderOptions":{"environment":"Rim Highlights","ambientOcclusion":{"enabled":false,"radius":10,"intensity":0.4},"toneMap":{"method":1,"exposure":-9,"lightMultiplier":-1e-20},"appearance":{"ghostHidden":true,"ambientShadow":false,"antiAliasing":true,"progressiveDisplay":true,"displayLines":true}},"cutplanes":[]}');
        //     console.log("Restoring State for Tile:", tileId);
        //     break;
        // case "0004":
        //     originalState = JSON.parse('{"guid":"f075a989156eb711400","seedURN":"dXJuOmFkc2sub2JqZWN0czpvcy5vYmplY3Q6Y29uZmlnX2hzc2luc3RydW1lbnRpL0hTU19JbnN0cnVtZW50X0kuemlw","overrides":{"transformations":[]},"objectSet":[{"id":[],"isolated":[],"hidden":[],"explodeScale":0,"idType":"lmv"}],"viewport":{"name":"","eye":[-163.8662266489145,0,101.51004011675508],"target":[0,0,0],"up":[0,1,0],"worldUpVector":[0,1,0],"pivotPoint":[0,0,0],"distanceToOrbit":192.76002822332916,"aspectRatio":2.0663910331477187,"projection":"perspective","isOrthographic":false,"fieldOfView":46.48761986856245},"renderOptions":{"environment":"Rim Highlights","ambientOcclusion":{"enabled":false,"radius":7.3109139716724485,"intensity":0.4},"toneMap":{"method":1,"exposure":-9,"lightMultiplier":-1e-20},"appearance":{"ghostHidden":true,"ambientShadow":false,"antiAliasing":true,"progressiveDisplay":true,"displayLines":true}},"cutplanes":[]}');
        //     console.log("Restoring State for Tile:", tileId);
        //     break;
        default:
            console.log("Sorry, no model selected");
    }


    viewer.restoreState(originalState, false, false);
}

/**
    * toggle explosion motion
    * @param  boolean cancelMotion - true if cancel motion is requested
    */
export function toggleExplosion(cancelMotion) {
    if (cancelMotion || isExploding) {
        cancelAnimationFrame(explosionReq);
        isExploding = false;
        if (cancelMotion) {
            explodeScale = 0;
            viewer.explode(explodeScale);
        }
    } else {
        explodeMotion();
        isExploding = true;
    }
}

/**
  * Recursive function for calling requestAnimationFrame for explode motion
*/

export function explodeMotion(timestamp) {
    if (!startExplosion) {
        startExplosion = timestamp;
    }
    var progress = timestamp - startExplosion;
    startExplosion = timestamp;
    var explodeStep = 0.0002 * (progress || 0);
    // explode outward and inward
    if (outwardExplosion) {
        explodeScale += explodeStep;
    } else {
        explodeScale -= explodeStep;
    }
    if (explodeScale > 1) {
        outwardExplosion = false;
        explodeScale = 1; // this solves when user go to another browser tab
    } else if (explodeScale < 0) {
        outwardExplosion = true;
        explodeScale = 0; // this solves when user go to another browser tab
    }
    viewer.explode(explodeScale);
    explosionReq = window.requestAnimationFrame(explodeMotion);
};

export function insertModel(urn, offset) {
    addViewable('urn:' + urn, offset);
}

export async function addViewable(documentId, offset) {
    Autodesk.Viewing.Document.load(
        documentId,
        function (doc) { // onLoadCallback
            var viewables = doc.getRoot().search({ 'type': 'geometry' })
            viewer.loadDocumentNode(doc, viewables[0], {
                preserveView: true,
                keepCurrentModels: true,
                placementTransform: (new THREE.Matrix4()).setPosition(4, 3, 2),
                globalOffset: { x: 0, y: 0, z: 0 }

            })
                .then(onLoadFinished);
        },
        function (errorMsg) { // onErrorCallback
            console.log(errorMsg);
        }
    )

}
/**
    * recursive function for rotation motion each time page refreshes
    */
export function rotateMotion(timestamp) {
    if (!startRotation) {
        startRotation = timestamp;
    }
    var progress = timestamp - startRotation;
    startRotation = timestamp;
    var rotateStep = 0.0005 * (progress || 0);
    // get the up axis
    var worldUp = viewer.navigation.getWorldUpVector();
    // get the current position
    var pos = viewer.navigation.getPosition();
    // copy that position
    var position = new THREE.Vector3(pos.x, pos.y, pos.z);
    // set the rotate axis
    var rAxis = new THREE.Vector3(worldUp.x, worldUp.y, worldUp.z);
    var matrix = new THREE.Matrix4().makeRotationAxis(rAxis, rotateStep);
    //apply the new position
    position.applyMatrix4(matrix);
    viewer.navigation.setPosition(position);
    rotationReq = window.requestAnimationFrame(rotateMotion);
}


/**
* Toggle the rotation movement
* @param  boolean cancelMotion true if motion is to be cancelled
*/
export function toggleRotation(cancelMotion) {
    if (cancelMotion || isRotating) {
        cancelAnimationFrame(rotationReq);
        isRotating = false;
    } else {
        rotateMotion();
        isRotating = true;
    }
}



export function stopMotion() {
    toggleExplosion(true);
    toggleRotation(true);
}


const Helpers = {
    launchViewer,
    loadDocument
};

export default Helpers;
